import { connect } from "react-redux";
import { ColorPrediction as Component } from "@learningblocks/storybook-components";
import {
  onColorPredictionSelect,
  onColorPredictionSubmit,
  onColorPredictionReset,

  //onColorPredictionUpdate,
} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    // onColorPredictionUpdate: (data) => {
    //   dispatch(onColorPredictionUpdate(data))
    // },
    onColorSelect: (data) => {
      dispatch(onColorPredictionSelect(data));
    },
    onSubmit: (data) => {
      dispatch(onColorPredictionSubmit(data));
    },
    onReset: (data) => {
      dispatch(onColorPredictionReset(data));
    },
  };
}

export const ColorPrediction = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
